import React from "react";
import { Avatar, AvatarProps } from "@mui/material";
import { useAuthenticatedFileUrl } from "../../hooks/useAuthenticatedFileUrl";
import { isProtectedApiFileUrl } from "../../utils/authenticatedFileUrl";

type AuthenticatedAvatarProps = AvatarProps & {
  src?: string | null;
};

export const AuthenticatedAvatar: React.FC<AuthenticatedAvatarProps> = ({
  src,
  ...props
}) => {
  const { url } = useAuthenticatedFileUrl(src ?? undefined);
  const avatarSrc =
    url ?? (src && isProtectedApiFileUrl(src) ? undefined : src || undefined);

  return <Avatar {...props} src={avatarSrc} />;
};
